import React from 'react'
import Image from './Image'

import styles from './product.module.scss'

export default function DesignImage({product, hideDesignImage}) {
    return (
        <If condition={product.preview.designUrl}>
            <div
                className={styles.designImgContainer}
                style={{backgroundColor: product.color.hexCode || 'white'}}
                onMouseLeave={hideDesignImage}
            >
                <Image
                    className={styles.designImg}
                    src={product.preview.designUrl}
                    alt={'Дизайн-превью'}
                    title={'Дизайн-превью'}
                    ready={product.ready}
                />
            </div>
        </If>
    )
}
